import "objectFitPolyfill"

import smoothScroll from "smoothscroll-polyfill"

smoothScroll.polyfill()

export const onClientEntry = () => {
  const script = document.createElement("script")
  script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.GATSBY_GOOGLE_RECAPTCHA_KEY}`
  script.async = true
  document.head.appendChild(script)
}
